import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Formik, Form, ErrorMessage } from 'formik';
import { AddEmailSchema } from '../../validation';

import FloatingLabel from "floating-label-react";
import "floating-label-react/styles.css";

import { sendEmailForSocial } from '../../actions'
import { ROLE_TYPE } from '../../../../constants/roles';
import { PAGE_ROUTES } from '../../../../constants/pageRoutes';

import ShowErrorToasts from '../../../global/errorToast';

const mapStateToProps = state => ({
  registration:state.Registration,
  global:state.Global
});

class AddEmail extends Component {
  constructor(props) {
    super(props);

    this.onSkip = this.onSkip.bind(this);
    this.onBack = this.onBack.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onBack = () => {
    let { history } = this.props;
    let { userType } = this.props.registration.formData;
    let backUrl = userType === ROLE_TYPE.renter
      ? PAGE_ROUTES.RENTER_SIGN_UP_1
      : PAGE_ROUTES.OWNER_SIGN_UP_1;
    history.push(backUrl);
  }

  onSkip = () => {
    let { history } = this.props;
    history.push(PAGE_ROUTES.DASHBOARD);
  }

  handleSubmit = ( values, form ) => {
    let { dispatch } = this.props;
    let { userId } = this.props.global;
    let { email, userType } = values;
    dispatch(sendEmailForSocial(email, userType, userId));
  }

  render() {

    let values = this.props.registration.formData;

    return (
      <div className="main-container">
        <ShowErrorToasts />
        <div className="main-wrapper">
          <div className="left-section">
            <div className="white-background">
              <div className="content-section">
                <h1 className="title">Change Email Address</h1>
                <p className="detail-text">Please set a new email address for your account.</p>
                <div className="signin-page">
                  <Formik
                    validationSchema={AddEmailSchema}
                    initialValues={values}
                    onSubmit={this.handleSubmit}>
                    {formProps => (
                      <Form className="form-section">
                        <div className="form-group">
                          <FloatingLabel
                            type="email"
                            id="email"
                            className="form-control"
                            name="email"
                            placeholder="Email Address"
                            value={formProps.values.email}
                            onChange={formProps.handleChange}
                          />
                          <ErrorMessage name='email' render={msg => <div className="invalid-feedback">{msg}</div>} />
                        </div>
                        <div className="combo-button">
                          <div className="back-button">
                            <button type="button" className="btn dark" onClick={this.onSkip}>Skip</button>
                          </div>
                          <div className="signin-button">
                            <button type="submit" className="btn primary">Set Email Address</button>
                          </div>
                        </div>
                      </Form>)}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
          <div className="right-section">
            <div className="bg-image"></div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(AddEmail));
